import _ from "lodash";
import { STATEMENT_END_LOCATION_ID } from "../../../../configs/constants";

/**
 * Manage LocationTypes properties
 */
export default class LocationType {
  constructor(data = {}) {
    this.locationTypeId = "";
    this.locationType = "";
    this.label = "";
    this.categories = [];
    this.statements = [];

    this.setData(data);
  }

  resetData(data = {}) {
    this.categories = [];
    this.statements = [];

    this.setData(data);
  }

  setData(data = {}) {
    this.locationTypeId = data.locationTypeId || this.locationTypeId || "";
    this.locationType = data.locationType || this.locationType || "";
    this.label = data.label || this.label || "";
    this.categories = data.categories || this.categories || [];
    this.statements = data.statements || this.statements || [];
  }

  getData() {
    this.statements = _.orderBy(this.statements, ["priority", "id"], ["asc", "asc"]);

    return {
      locationTypeId: this.locationTypeId,
      locationType: this.locationType,
      label: this.label,
      categories: this.categories,
      statements: this.statements
    };
  }

  /**
   * Retreive locationType from [locationType]
   * @param {string} locationTypeId
   * @returns {*}
   */
  getLocationType(locationTypeId) {
    const locationTypeIndex = _.findIndex(this.locationTypes, o => {
      return o.locationTypeId === locationTypeId;
    });

    if (locationTypeIndex === -1) {
      return null;
    }

    return this.locationTypes[locationTypeIndex];
  }

  /**
   * Add locationType to [locationType]
   * @param {Object} locationType
   * @returns {Object}
   */
  addLocationType(locationType = {}) {
    let locationTypeInstance = { ...locationType };
    locationTypeInstance.statements = locationTypeInstance.statements || [];
    this.locationTypes.push(locationTypeInstance);
    return locationTypeInstance;
  }

  removeLocationType(locationTypeId) {
    this.locationTypes = _.remove(this.locationTypes, o => {
      return o.locationTypeId === locationTypeId;
    });
  }

  /**
   * Retreive a statement
   * @param {string} statementId
   * @returns {*}
   */
  getStatement(statementId) {
    const statementIndex = _.findIndex(this.statements, o => {
      return o.statementId === statementId;
    });

    if (statementIndex === -1) {
      return null;
    }

    return this.statements[statementIndex];
  }

  /**
   * Add a statement to statements list
   * @param {Object} statement
   * @returns {*}
   */
  addStatement(statement) {
    let statementInstance = this.getStatement(statement.statementId);

    if (!statementInstance) {
      statementInstance = _.cloneDeep(statement); // { ...statement };
      statementInstance.kpis = [];
      statementInstance.medias = [];
      statementInstance.mediaQuantity = [
        {
          type: "Photo",
          quantity: "0"
        },
        {
          type: "Video",
          quantity: "0"
        },
        {
          type: "Audio",
          quantity: "0"
        }
      ];

      this.statements.push(statementInstance);
      /*this.statements.sort(function(a = {}, b = {}) {
				return a.id - b.id;
			});*/
    }

    this.statements = _.orderBy(this.statements, ["priority", "id"], ["asc", "asc"]);
    return statementInstance;
  }

  /**
   * Add end location statement
   */
  addEndLocationStatement() {
    const statement = {
      _id: "",
      client_id: [],
      actions: [],
      id: STATEMENT_END_LOCATION_ID,
      label: "Fin d'emplacement",
      description: "Fin d'emplacement",
      condition: false,
      question: "Fin d'emplacement",
      format: "Boolean",
      display: true,
      type: "inline",
      priority: 10001,
      __v: 0,
      title: "Fin d'emplacement",
      statementId: STATEMENT_END_LOCATION_ID + "",
      displayType: "inline",
      conditions: [],
      conditionStatus: true,
      medias: [],
      mediaQuantity: [
        {
          type: "Photo",
          quantity: "0"
        }
      ],
      kpis: []
    };
    this.addStatement(statement);
  }

  /**
   * Remove a statement from statements list
   * @param {Object} statement
   */
  removeStatement(statement = {}) {
    _.remove(this.statements, o => {
      return o.statementId === statement.statementId;
    });
  }

  /**
   * Set statement.label property,  statements[statement.statementId].label
   * @param {Object} statement
   * @param {String} label
   */
  setLabelStatement(statement, label) {
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) {
      statementInstance = this.addStatement(statement);
    }

    statementInstance.label = label;
  }

  /**
   * add action to statement,  statements[statement.statementId].actions
   * @param {Object} statement
   * @param {String} action
   */
  updateActionStatement(statement, action = {}, add = true) {
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) {
      statementInstance = this.addStatement(statement);
    }

    statementInstance.actions = statementInstance.actions || [];
    if (add && !statementInstance.actions.some(v => v.id === action.id)) {
      statementInstance.actions.push(action);
    } else if (!add) {
      const actionIndex = statementInstance.actions.findIndex(v => v.id === action.id);
      if (actionIndex !== -1) {
        statementInstance.actions.splice(actionIndex, 1);
      }
    }
  }

  /**
   * Add a kpi to statement.kpis, statements[statement.statementId].kpis[kpi]
   * @param {Object} statement
   * @param {Object} kpi
   */
  addKpi(statement, kpi) {
    if (!kpi || !statement) {
      return;
    }
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) {
      statementInstance = this.addStatement(statement);
    }

    const kpiIndex = _.findIndex(statementInstance.kpis, o => {
      return o.id === kpi.id;
    });

    if (kpiIndex === -1) {
      statementInstance.kpis = statementInstance.kpis || [];
      statementInstance.kpis.push(kpi);

      statementInstance.kpis = _.orderBy(statementInstance.kpis, ["priority", "id"], ["asc", "asc"]);
      /*statementInstance.kpis.sort(function(kpi1 = {}, kpi2 = {}) {
				const kpiId1 = kpi1.id || 0;
				const kpiId2 = kpi2.id || 0;
				return kpiId1 < kpiId2 ? -1 : 1;
			});*/
    }
  }

  /**
   * Check whether kpi is selected
   * @param statement
   * @param kpi
   * @returns {boolean}
   */
  isKpiSelected(statement = {}, kpi = {}) {
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) return false;

    const kpiIndex = _.findIndex(statementInstance.kpis, { id: kpi.id });

    return kpiIndex !== -1;
  }

  /**
   * Returns selected kpis in the statement
   * @param statement
   * @returns {Array}
   */
  getKpisSelected(statement) {
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) return [];
    return statementInstance.kpis || [];
  }

  /**
   * Remove a kpi from statement. statements[statement.statementId].kpis[kpi]
   * @param {Object} statement
   * @param {Object} kpi
   * @returns {null}
   */
  removeKpi(statement, kpi) {
    const statementInstance = this.getStatement(statement.statementId);
    if (statementInstance) {
      _.remove(statementInstance.kpis, o => {
        return o.id === kpi.id;
      });

      if (statementInstance.kpis.length === 0) {

        this.setMediaValue(statement, "Photo", "0");
        //this.removeStatement(statement);
      }
    }
  }

  /**
   * Set statement.displayType, statements[statement.statementId].displayType
   * @param {Object} statement
   * @param {string} displayType
   */
  setDisplayType(statement, displayType) {
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) {
      statementInstance = this.addStatement(statement);
    }

    statementInstance.displayType = displayType;
  }

  /**
   * Set statement.medias and statement.mediaQuantity, statements[statement.statementId].medias/mediaQuantity
   * @param {Object} statement
   * @param {string} mediaType
   * @param {string} value
   */
  setMediaValue(statement, mediaType, value) {
    let statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) {
      return;
    }

    if(statementInstance.kpis.length === 0){
      value = "0"
    }

    //set mediaQuantity property
    const mediaIndex = _.findIndex(statementInstance.mediaQuantity, {
      type: mediaType
    });
    statementInstance.mediaQuantity[mediaIndex].quantity = value || "0";

    //set medias property
    statementInstance.medias = [];
    statementInstance.mediaQuantity.map((mediaQuantityItem, index) => {
      const { type, quantity } = mediaQuantityItem;
      for (let i = 0; i < quantity; i++) {
        statementInstance.medias.push({
          type: type
        });
      }
    });
  }

  getMediaQuantity(statement, mediaType) {
    const statementInstance = this.getStatement(statement.statementId);
    if (!statementInstance) return "0";
    const mediaIndex = _.findIndex(statementInstance.mediaQuantity, {
      type: mediaType
    });
    return statementInstance.mediaQuantity[mediaIndex].quantity || "0";
  }

  /**
   * Returns true if the statement contains at least one kpis
   * @param {string} locationTypeId
   * @param {string} statementId
   * @returns {boolean}
   */
  statementContainsKpis(statementId) {
    let statementInstance = this.getStatement(statementId);
    if (!statementInstance) {
      return false;
    }

    return statementInstance.kpis.length > 0;
  }

  /**
   * Returns the number of kpi selected
   * @returns {number}
   */
  nbKpiSelected() {
    let nbKpis = 0;
    for (let i = 0; i < this.statements.length; i++) {
      const statement = this.statements[i];
      if (!statement.kpis) continue;
      nbKpis += statement.kpis.length;
    }
    return nbKpis;
  }
}



// WEBPACK FOOTER //
// src/components/survey/create/SurveyStepActionsKpi/LocationType.js